import { FOOTER_PREMIUM } from "../common/footer";
import { ALERT_HEADER } from "../common/header";

/**
 * World-Class Trial Expiring Template
 * Features: Urgency countdown, usage summary, plan comparison, compelling upgrade incentives
 */
export const trialExpiring = `
<mjml>
  <mj-head>
    <mj-title>Your Trial Ends in {{days_remaining}} Days - Don't Lose Access!</mj-title>
    <mj-preview>Upgrade now to keep your chatbots running</mj-preview>
    <mj-attributes>
      <mj-all font-family="'Segoe UI', Arial, sans-serif" />
      <mj-text font-size="16px" color="#334155" line-height="1.6" />
      <mj-button font-family="'Segoe UI', Arial, sans-serif" font-size="16px" font-weight="600" />
    </mj-attributes>
    <mj-style>
      .urgency-badge { background: linear-gradient(135deg, #EF4444, #DC2626); color: white; padding: 8px 20px; border-radius: 25px; font-size: 13px; font-weight: 700; letter-spacing: 0.5px; }
      .countdown-box { background: linear-gradient(135deg, #1E293B, #0F172A); border-radius: 16px; }
      .plan-card { border: 2px solid #e2e8f0; border-radius: 12px; transition: all 0.3s; }
      .plan-recommended { border: 2px solid #1939B7; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#fef2f2">
    \${ALERT_HEADER("Trial Ending Soon", "Don't lose access to your chatbots", "#EF4444")}

    <!-- Countdown Section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="0 0 16px 16px">
      <mj-column>
        <mj-text align="center" padding-bottom="15px">
          <span style="background: linear-gradient(135deg, #EF4444, #DC2626); color: white; padding: 8px 24px; border-radius: 25px; font-size: 13px; font-weight: 700; letter-spacing: 0.5px;">&#9888; ACTION REQUIRED</span>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Countdown Timer -->
    <mj-section background-color="#1E293B" padding="35px 30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="14px" color="rgba(255,255,255,0.8)" align="center" padding-bottom="15px">
          Your free trial ends in
        </mj-text>
        <mj-text font-size="72px" color="#EF4444" font-weight="800" align="center" padding="0" line-height="1">
          {{days_remaining}}
        </mj-text>
        <mj-text font-size="20px" color="rgba(255,255,255,0.9)" align="center" padding-top="10px" letter-spacing="3px">
          DAYS
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Greeting -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="22px" color="#0f172a" font-weight="700" padding-bottom="12px">
          Hi {{first_name}},
        </mj-text>
        <mj-text font-size="15px" color="#64748b">
          Your {{product_name}} free trial is ending soon. Upgrade now to keep your chatbots running and avoid any interruption to your customer conversations.
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Trial Summary -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="12px" color="#1939B7" font-weight="700" text-transform="uppercase" letter-spacing="1px" padding-bottom="20px">
          Your Trial Summary
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="16px">
      <mj-column width="25%" padding="10px">
        <mj-text font-size="32px" color="#1939B7" font-weight="700" align="center" padding="0">
          {{chatbots_created}}
        </mj-text>
        <mj-text font-size="12px" color="#64748b" align="center" padding-top="5px">
          Chatbots Created
        </mj-text>
      </mj-column>
      <mj-column width="25%" padding="10px">
        <mj-text font-size="32px" color="#10B981" font-weight="700" align="center" padding="0">
          {{conversations_handled}}
        </mj-text>
        <mj-text font-size="12px" color="#64748b" align="center" padding-top="5px">
          Conversations
        </mj-text>
      </mj-column>
      <mj-column width="25%" padding="10px">
        <mj-text font-size="32px" color="#8B5CF6" font-weight="700" align="center" padding="0">
          {{leads_captured}}
        </mj-text>
        <mj-text font-size="12px" color="#64748b" align="center" padding-top="5px">
          Leads Captured
        </mj-text>
      </mj-column>
      <mj-column width="25%" padding="10px">
        <mj-text font-size="32px" color="#F59E0B" font-weight="700" align="center" padding="0">
          {{hours_saved}}h
        </mj-text>
        <mj-text font-size="12px" color="#64748b" align="center" padding-top="5px">
          Time Saved
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Warning Section -->
    <mj-section background-color="#FEF3C7" padding="25px 30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="16px" color="#92400E" font-weight="600" padding-bottom="10px">
          &#9888; What happens if you don't upgrade?
        </mj-text>
        <mj-text font-size="14px" color="#92400E" line-height="1.8">
          &#8226; Your chatbots will stop responding to visitors<br/>
          &#8226; Existing conversation data retained for 30 days<br/>
          &#8226; Your configurations and flows will be saved
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Plans Section -->
    <mj-section background-color="#ffffff" padding="30px 30px 15px" border-radius="16px 16px 0 0">
      <mj-column>
        <mj-text font-size="22px" color="#0f172a" font-weight="700" align="center" padding-bottom="8px">
          Choose Your Plan
        </mj-text>
        <mj-text font-size="14px" color="#64748b" align="center">
          Based on your trial usage, we recommend the {{recommended_plan}} plan.
        </mj-text>
      </mj-column>
    </mj-section>

    <mj-section background-color="#ffffff" padding="15px 20px 30px" border-radius="0 0 16px 16px">
      <mj-column width="48%" padding="10px">
        <mj-text padding="25px" border="2px solid #e2e8f0" border-radius="12px">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: 700; color: #0f172a;">{{plan_1_name}}</span><br><br>
            <span style="font-size: 36px; font-weight: 800; color: #1939B7;">{{plan_1_price}}</span>
            <span style="font-size: 14px; color: #64748b;">/month</span><br><br>
            <span style="font-size: 13px; color: #64748b;">{{plan_1_features}}</span><br><br>
            <a href="{{plan_1_url}}" style="background: #ffffff; border: 2px solid #1939B7; color: #1939B7; padding: 12px 30px; border-radius: 8px; text-decoration: none; font-weight: 600; display: inline-block;">Select Plan</a>
          </div>
        </mj-text>
      </mj-column>
      <mj-column width="48%" padding="10px">
        <mj-text padding="25px" border="2px solid #1939B7" border-radius="12px" background-color="#f8fafc">
          <div style="text-align: center;">
            <span style="background: #1939B7; color: white; padding: 4px 12px; border-radius: 12px; font-size: 11px; font-weight: 700;">RECOMMENDED</span><br><br>
            <span style="font-size: 18px; font-weight: 700; color: #0f172a;">{{plan_2_name}}</span><br><br>
            <span style="font-size: 36px; font-weight: 800; color: #1939B7;">{{plan_2_price}}</span>
            <span style="font-size: 14px; color: #64748b;">/month</span><br><br>
            <span style="font-size: 13px; color: #64748b;">{{plan_2_features}}</span><br><br>
            <a href="{{plan_2_url}}" style="background: #1939B7; color: white; padding: 12px 30px; border-radius: 8px; text-decoration: none; font-weight: 600; display: inline-block;">Select Plan</a>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Upgrade CTA -->
    <mj-section background-color="#1939B7" padding="35px 30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="24px" color="#ffffff" font-weight="700" align="center" padding-bottom="10px">
          Don't Let Your Chatbots Go Silent
        </mj-text>
        <mj-text font-size="15px" color="rgba(255,255,255,0.9)" align="center" padding-bottom="20px">
          Upgrade now and get {{upgrade_bonus}}.
        </mj-text>
        <mj-button background-color="#2DD4BF" color="#0F172A" href="{{upgrade_url}}" border-radius="8px" padding="18px 45px" font-size="17px" font-weight="700">
          Upgrade Now &#8594;
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="15px 0"></mj-section>

    <!-- Help Section -->
    <mj-section background-color="#ffffff" padding="25px 30px" border-radius="16px">
      <mj-column>
        <mj-text font-size="15px" color="#64748b" align="center">
          <strong>Questions about pricing?</strong><br/>
          Reply to this email or <a href="{{contact_url}}" style="color: #1939B7; text-decoration: none; font-weight: 600;">schedule a call</a> with our team.
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Spacer -->
    <mj-section padding="10px 0"></mj-section>

    \${FOOTER_PREMIUM}
  </mj-body>
</mjml>
`;

export default {
  id: "trialExpiring",
  name: "Trial Expiring - Upgrade Prompt",
  category: "sequences",
  purpose: "sequence" as const,
  description:
    "A world-class urgency-driven email for expiring trials featuring dramatic countdown, usage statistics, plan comparison cards, and compelling upgrade incentives.",
  features: [
    "Dramatic countdown display",
    "Trial usage statistics",
    "Warning of consequences",
    "Side-by-side plan comparison",
    "Upgrade bonus incentive",
    "Premium footer with support",
  ],
  subject: "&#9203; Your Trial Ends in {{days_remaining}} Days - Don't Lose Access!",
  subTitle: "Upgrade now to keep your chatbots running",
  mjmlTemplate: trialExpiring,
  tags: ["sequence", "trial", "expiring", "upgrade", "conversion", "urgency"],
};
